import { render, staticRenderFns } from "./NotebookItem.vue?vue&type=template&id=09fe89e2&scoped=true"
import script from "./NotebookItem.vue?vue&type=script&lang=ts"
export * from "./NotebookItem.vue?vue&type=script&lang=ts"
import style0 from "./NotebookItem.vue?vue&type=style&index=0&id=09fe89e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fe89e2",
  null
  
)

export default component.exports